import * as React from "react";
import {
    NotificationSubscriptionsSection,
    SubscriptionSection,
    Subscription,
    Accordion,
    isSubscriptionActive,
    RoleType,
    ToggleSwitch,
    TitleBar
} from "modules/common";
import { useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    activatedSubscriptions?: string[];
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    roleType?: RoleType;
}

export const NotificationSubscriptions: React.FC<Props> = ({
    activatedSubscriptions,
    onChange,
    roleType,
}) => {
    const { fontSize } = useContext(AccessibilityContext);
    if (!activatedSubscriptions) {
        return null;
    }

    const userCanSubscribe = (roleType: RoleType, allowedRoleTypes?: RoleType[]) => {
        return allowedRoleTypes == undefined || allowedRoleTypes.includes(roleType);
    };

    const renderSubscriptionRow = (item: Subscription) =>
        roleType && userCanSubscribe(roleType, item.roles) ? (
            <div key={`${item.category}_${item.id}`} className="subscription-row">
                <div>
                    <label
                        htmlFor={`${item.category}_${item.id}`}
                        className="subscription-row__label"
                    >
                        {item.title}
                    </label>
                </div>
                <ToggleSwitch
                    htmlFor={`${item.category}_${item.id}`}
                    value={`${item.category}_${item.id}`}
                    onChange={onChange}
                    checked={isSubscriptionActive(activatedSubscriptions, item.category, item.id)}
                    className="subscription-row__toggle"
                />
            </div>
        ) : null;

    const renderSubgroup = (subgroup: SubscriptionSection) =>
        roleType && userCanSubscribe(roleType, subgroup.roles) ? (
            <div key={subgroup.groupTitle}>
                <Accordion title={subgroup.groupTitle!} className="subgroup-accordion">
                    {subgroup.customComponent ? (
                        <subgroup.customComponent />
                    ) : (
                        <div className="subscriptions">
                            {subgroup.subscriptions.map(renderSubscriptionRow)}
                        </div>
                    )}
                </Accordion>
            </div>
        ) : null;

    const renderGroupContent = (section: SubscriptionSection) => (
        <div className="subscriptions" key={section.groupTitle}>
            {section.subscriptions.map(renderSubscriptionRow)}
            {section.subgroups?.map(renderSubgroup)}
        </div>
    );

    const renderGroup = (section: SubscriptionSection, isLast: boolean) => (
        <div key={section.groupTitle}>
            <Accordion
                title={section.groupTitle ?? ""}
                className="subscriptions-accordion"
                isButtonWithBorder
            >
                {renderGroupContent(section)}
            </Accordion>
            {!isLast ? <div className="thin-separator" /> : <div className="thin-spacer"></div>}
        </div>
    );

    const renderRegularSection = (section: SubscriptionSection) => (
        <div className="subscriptions" key={section.subscriptions[0].id}>
            {section.subscriptions.map(renderSubscriptionRow)}
        </div>
    );

    return (
        <div>
            <TitleBar>
                <TitleBar.Left>
                    <span className="title-bar-text profile-title" style={{ fontSize: `${fontSize}%` }}>Predbilježbe</span>
                </TitleBar.Left>
            </TitleBar>
            <span className="subscriptions__description">
                Primajte pravovremene obavijesti iz određenih kategorija ovisno o vašim interesima.
            </span>
            {NotificationSubscriptionsSection.map((section, index) =>
                section.groupTitle
                    ? renderGroup(section, index === NotificationSubscriptionsSection.length - 1)
                    : renderRegularSection(section)
            )}
        </div>
    );
};
